import { render, staticRenderFns } from "./HedgingInstrumentResultsBlock.vue?vue&type=template&id=73fd38b8&scoped=true"
import script from "./HedgingInstrumentResultsBlock.vue?vue&type=script&lang=js"
export * from "./HedgingInstrumentResultsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fd38b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VLazy,VRow,VSpacer})
